module.exports = __webpack_public_path__ + "img/circleMen.330212c.png";